import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './shared/guards/auth-guard';
import { CommonComponent } from './common/common.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: '',
    component: CommonComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'autorizacao',
        loadChildren: () => import('./pesca/pesca-cadastrar/autorizacao/autorizacao.module').then(m => m.AutorizacaoModule)
      },
      {
        path: 'usuario',
        loadChildren: () => import('./pesca/pesca-cadastrar/usuario/usuario.module').then(m => m.UsuarioModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {useHash: true})
  ],
  exports: [
    RouterModule
  ],
})
export class AppRoutingModule { }
